import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";

const steps = [
  ["Analyse", "Wir sehen uns IT, Räume und Abläufe vor Ort an und bewerten, was Käufer kritisch sehen würden.", "2–4 Wochen"],
  ["Konzept", "Ein gemeinsamer Plan aus IT-Roadmap und Raumkonzept, priorisiert nach Wirkung auf den Unternehmenswert.", "3–6 Wochen"],
  ["Umsetzung", "Migration, Sicherheit, Umbau und Einrichtung – koordiniert, damit Ihr Tagesgeschäft weiterläuft.", "nach Umfang"],
  ["Übergabe", "Dokumentation für Due Diligence und Begleitung der Nachfolger, bis alles in neuen Händen läuft.", "laufend"],
];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="ablauf" data-testid="process-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-40">
      <SectionHead id="ablauf" eyebrow="03 — Ablauf" title={["Vier Schritte bis", <span key="i" className="italic text-[var(--clay)]">zur Übergabe.</span>]} />
      <div ref={ref} className="relative mt-16 lg:ml-[33.333%] lg:mt-20">
        <div className="absolute left-[11px] top-2 h-full w-px bg-[var(--line)]" />
        <motion.div style={{ scaleY }} className="absolute left-[11px] top-2 h-full w-px origin-top bg-[var(--clay)]" />
        {steps.map(([title, text, dur], i) => (
          <Reveal key={title} delay={0.05}>
            <div data-testid={`process-step-${i + 1}`} className={`relative grid gap-3 ${i < steps.length - 1 ? "pb-16" : ""} pl-12 sm:grid-cols-12 sm:gap-6`}>
              <span className="absolute left-0 top-2 h-[23px] w-[23px] rounded-full border border-[var(--clay)] bg-[var(--stone)]">
                <span className="absolute inset-[6px] rounded-full bg-[var(--clay)]" />
              </span>
              <span className="font-mono-d text-sm text-[var(--clay-2)] sm:col-span-2 sm:pt-3">0{i + 1}</span>
              <div className="sm:col-span-7">
                <h3 className="font-serif-d text-4xl tracking-tight sm:text-5xl">{title}</h3>
                <p className="mt-3 max-w-xl text-base leading-relaxed text-[var(--ink-2)]">{text}</p>
              </div>
              <span className="font-mono-d text-xs uppercase tracking-wider text-[var(--ink-2)] sm:col-span-3 sm:pt-4 sm:text-right">{dur}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
